'use strict';

import React, { Component } from 'react'

import Layout from '@Layout/FrontOffice'

import getFormStatus from '@/Form/Functions/getFormStatus'

import ajaxRequest from '@function/ajax/ajaxRequest'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'
import Link   from '@Pure/Link'

const { app } = window;

export default class AppTokenLoginPage extends Component
{
	state = { };

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();
	}

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		component.loginWithToken();
	}

	loginWithToken = async () =>
	{
		const component = this, props = this.props, state = this.state;

		let pathname = document.location.pathname;

		if (pathname.endsWith('/')) pathname = pathname.slice(0, -1);

		const token = pathname.slice(pathname.lastIndexOf('/')+1);

		if (!token || !token.trim())
		{
			return component.setState(
			{
				loading: false,
				error: 'Le lien que vous avez suivi est invalide, veuillez réessayer.'
			});
		}

		component.setState({ loading: true });

		try
		{
			var response = await ajaxRequest('/login',
			{
				data: { token, app_token_login: true },
				min_duration: 3000
			});
		}
		catch (e)
		{
			console.error(e);

			return component.setState({ ...e });
		}

		component.setState({ loading: false });

		app.state.session = response.session;

		app.state.cart = [];

		app.state.cart_fetched = true;

		app.state.order_process.fetched = true;

		app.emit('sessionChange', { label: 'login' });

		if (response.pathname)
		{
			props.history.push(response.pathname);
		}
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const loader = state.loading === true ?
		(
			<Loader className="c-loader" bemit={ ['primary', 'bg-white'] }
				text="connexion en cours"
			/>
		)
		: undefined;

		const content =
		(
			<div className="app-autologin-container">

				<div className="app-autologin">

					<div className="home-form__img-container">
						<Image className="home-form__img"
							src="/images/background/accueil_synergies@1500.jpg"
						/>
					</div>

					<div className="app-autologin__content">
						<div className="home-tabs">
							<Link href="/login" className="c-tab">
								<div className="c-tab__label">Accueil</div>
							</Link>

							<Link href="/inscription" className="c-tab c-tab--active">
								<div className="c-tab__label">Automatique</div>
							</Link>
						</div>

						<div className="app-autologin__content-txt">
							<div className="o-content">
								{ getFormStatus(state) }
							</div>
						</div>

						{ loader }

					</div>

				</div>

			</div>
		);

		var output =
		(
			<Layout page_title="Login">

				<div className="u-table u-full-width"
					style={ { 'minHeight': '100%' } }>

					<div className="u-table-row">

						<div className="u-table-cell u-vertical-align-middle">

							{ content }

						</div>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
